class PulseGalleryColumn extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.pg-col__slide'));
    if (this.slides.length === 0) return;

    this.index = 0;
    this.slides[0].classList.add('is-active');

    const autoplay = this.dataset.autoplay !== 'false';
    if (!autoplay || this.slides.length < 2) return;

    this.duration = (parseFloat(this.dataset.duration) || 4) * 1000;
    this.speed = (parseFloat(this.dataset.speed) || 0.6) * 1000;
    this.pauseOnHover = this.dataset.pauseOnHover === 'true';

    this.start();

    if (this.pauseOnHover) {
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
    }
  }

  start() {
    if (this.timer) return;
    this.timer = setInterval(() => this.next(), this.duration);
  }

  stop() {
    clearInterval(this.timer);
    this.timer = null;
  }

  next() {
    const current = this.slides[this.index];
    this.index = (this.index + 1) % this.slides.length;
    const upcoming = this.slides[this.index];

    current.classList.remove('is-active');
    current.classList.add('is-leaving');
    upcoming.classList.add('is-active');

    setTimeout(() => {
      current.classList.remove('is-leaving');
    }, this.speed);
  }

  disconnectedCallback() {
    this.stop();
  }
}

if (!customElements.get('pulse-gallery-column')) {
  customElements.define('pulse-gallery-column', PulseGalleryColumn);
}
